/* Page escuela scripts
========================================================================== */

if (jQuery('#contenedor-slider-escuela').length !== 0) {
	document.getElementById('contenedor-slider-escuela').onclick = function () {
		this.classList.toggle('pantalla-completa');
	};
	
	var indice_slide = 1;
	mostar_slide(indice_slide);
	
	function cambiar_slide(n) {
		// Si le da a la flecha evitamos la pantalla completa
		document.getElementById('contenedor-slider-escuela').classList.toggle('pantalla-completa');
		mostar_slide(indice_slide += n);
	}
	
	function mostar_slide(n) {
		var i;
		var slides = document.getElementsByClassName("mySlides");
		if (n > slides.length) { indice_slide = 1 }
		if (n < 1) { indice_slide = slides.length }
		for (i = 0; i < slides.length; i++) {
			slides[i].style.display = "none";
		}
		slides[indice_slide - 1].style.display = "block";
		if (slides[indice_slide - 1].classList.contains('esVideo')) {
			slides[indice_slide - 1].firstElementChild.load(); // Para que el video empieze desde el principio cada vez que cambiamos de slide
			slides[indice_slide - 1].firstElementChild.play();
		}
	}
	
	// ESLIDES EN AUTOMATICO
	iniciar_intervalo_slides_escuela();
	var intervalo_slides_escuela;
	
	function iniciar_intervalo_slides_escuela() {
		intervalo_slides_escuela = setInterval(siguiente_slide, 4000);
	}
	
	function parar_intervalo_slides_escuela() {
		clearInterval(intervalo_slides_escuela);
	}
	
	function siguiente_slide() {
		mostar_slide(indice_slide += 1)
	}
	
	document.querySelector('.prev').addEventListener('mouseover', parar_intervalo_slides_escuela, false)
	document.querySelector('.prev').addEventListener('mouseleave', iniciar_intervalo_slides_escuela, false)
	document.querySelector('.next').addEventListener('mouseover', parar_intervalo_slides_escuela, false)
	document.querySelector('.next').addEventListener('mouseleave', iniciar_intervalo_slides_escuela, false)
}
